import { Button, Container, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import IdCardPrint from '../Components/IdPayment/IdCardPrint';
import IdPaymentLanding from '../Components/IdPayment/IdPaymentLanding';
const queryString = require('query-string');

class IdCardPrintContainer extends Component {


    state = {
        student_id: "",
        request_id: ""
    }
    componentDidMount() {
        let ss = queryString.parse(this.props.history.location.search);
        if (ss.studentId != undefined) {
            this.setState({
                student_id: ss.studentId,
                // optional: present only when printing from the ID Card Requests
                // panel. Without it this page behaves exactly as it always has.
                request_id: ss.requestId != undefined ? ss.requestId : ""
            })
        }
    }

    render() {
        return (
            <div>
                {this.state.student_id != "" && <IdCardPrint
                    student_id={this.state.student_id}
                    request_id={this.state.request_id}
                    user={this.props.user}
                />}



            </div>
        )
    }
}

export default withAuth(IdCardPrintContainer);